import productItem from "./ProductItem.vue";
import _style from "@/theme/css/common/color.scss";
export default {
  name: "ProductListSlider",
  components: {
    productItem: productItem
  },
  props: {
    title: String,
    list: {
      type: Array,
      default: []
    },
    titleColor: {
      type: String,
      default: ""
    },
    addCartBgColor: {
      type: String,
      default: _style.color_white
    }
  },
  data: function data() {
    return {
      sleder: 0,
      height: 0 // 商品列表高度
    };
  },
  computed: {
    style: function style() {
      return _style;
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var dom = _this.$el.querySelector('.Slider_box');
      if (dom) {
        _this.height = dom.clientHeight + 66 - 40; // 66 = .btn 高出.product_item的高度  40 = product_item的margin_bottom
      }
    });
  },
  methods: {
    left: function left() {
      this.sleder += 500;
      if (this.sleder > 0) {
        this.sleder = 0;
      }
    },
    right: function right() {
      this.sleder -= 500;
      var Box_width = -240 * this.list.length + this.$refs.Slider_box.clientWidth;
      if (this.sleder < Box_width) {
        this.sleder = Box_width;
      }
    },
    addCartHandle: function addCartHandle() {
      this.$emit("addCartHandle");
    }
  }
};